import React from "react";
import { Link } from "react-router-dom";
import FadeInSection from "../FadeInSection";
import "./Mythology.css";

const texts = [
  {
    citation:
      "Ovid. Metamorphoses. Translated by A. S. Kline, Poetry in Translation, 2000.",
    url: "https://ovid.lib.virginia.edu/trans/Ovhome.htm",
  },
  {
    citation:
      "Hesiod. Theogony. Translated by Hugh G. Evelyn-White, Harvard University Press, 1914.",
    url: "https://www.perseus.tufts.edu/hopper/text?doc=Perseus%3Atext%3A1999.01.0130",
  },
];

const artifacts = [
  {
    citation:
      "Narcissus and Echo, Roman Wall Painting (Fourth Pompeian Style). 45–79 CE, Museo Archeologico Nazionale di Napoli, Naples (inv. 9380).",
    url: "https://commons.wikimedia.org/wiki/File:Affresco_romano_-_Pompei_-_Narciso_ed_Eco.JPG",
  },
  {
    citation:
      "Gorgoneion Antefix (Roof Tile), Painted Terracotta. ca. 540 BCE, Metropolitan Museum of Art, New York (acc. 39.11.9).",
    url: "https://www.metmuseum.org/art/collection/search/253581",
  },
];

function BibList({ label, entries }) {
  return (
    <div className="myth-entry">
      <div className="myth-entry-header">
        <span className="myth-character">{label}</span>
      </div>
      {entries.map((e) => (
        <p className="myth-analysis myth-bib-entry" key={e.citation}>
          {e.citation}
          {e.url && (
            <>
              {" "}
              <a
                href={e.url}
                target="_blank"
                rel="noreferrer"
                className="myth-bib-link"
              >
                [link]
              </a>
            </>
          )}
        </p>
      ))}
    </div>
  );
}

export default function MythologyBibliography() {
  return (
    <FadeInSection>
      <div className="myth-myths-page">
        <section className="hero-section" id="myth-bibliography-header">
          <div className="container">
            <Link to="/mythology" className="back-link">← mythology respawned</Link>
            <h1 className="hero-name myth-page-title">bibliography</h1>
            <p className="hero-role">ancient texts and artifacts used on this site</p>
          </div>
        </section>

        <section className="myth-myths-section">
          <div className="container">
            <BibList label="ancient texts" entries={texts} />
            <BibList label="artifacts" entries={artifacts} />
          </div>
        </section>
      </div>
    </FadeInSection>
  );
}
